import React from 'react';
import ArrowUpIcon from 'assets/icons/arrowUp.svg?react';
import ArrowDownIcon from 'assets/icons/arrowDown.svg?react';
import styles from './KpiCard.module.css';

type KpiTrendDirection = 'up' | 'down' | 'flat';

type KpiTrend = {
    direction: KpiTrendDirection;
    text: React.ReactNode;
};

type KpiCardProps = {
    icon: React.ReactNode;
    title: string;
    value: React.ReactNode;
    meta?: React.ReactNode;
    trend?: KpiTrend;
};

function KpiCard({ icon, title, value, meta, trend }: KpiCardProps): JSX.Element {
    return (
        <div className={styles.kpiCard}>
            <div className={styles.kpiIcon}>{icon}</div>
            <div className={styles.kpiTextColumn}>
                <p className={styles.kpiTitle}>{title}</p>
                <div className={styles.kpiValueMetaRow}>
                    <p className={styles.kpiValue}>{value}</p>
                    {trend ? (
                        <p className={`${styles.kpiMeta} ${styles.deltaMeta} ${styles[trend.direction]}`}>
                            {trend.direction === 'up' && (
                                <span className={`${styles.deltaBadge} ${styles.deltaBadgeUp}`}>
                                    <ArrowUpIcon />
                                </span>
                            )}
                            {trend.direction === 'down' && (
                                <span className={`${styles.deltaBadge} ${styles.deltaBadgeDown}`}>
                                    <ArrowDownIcon />
                                </span>
                            )}
                            {trend.text}
                        </p>
                    ) : meta ? (
                        <p className={`${styles.kpiMeta} ${styles.kpiMetaInline}`}>{meta}</p>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export type { KpiTrendDirection };
export default KpiCard;
